import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P } from "../../AbstractElements";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useIsFetching } from "@tanstack/react-query";

//CARDS
import CandidateProfile from "./candidateProfile";
import Attachments from "./attachments";
import Remarks from "./remarks";
import Timeline from "./timeline";

const CandidateRecordContainer = () => {
  const { appl_no } = useParams<{ appl_no: string }>();

  const ApplNo = appl_no ? atob(decodeURIComponent(appl_no)) : "";

  return (
    <>
      <Breadcrumbs
        mainTitle={`Application No. ${ApplNo}`}
        parent="Recruitment / Candidate Profile"
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <div className="user-profile">
              <CandidateProfile ApplNo={ApplNo ?? ""} />
            </div>
            <Attachments ApplNo={ApplNo ?? ""} />
          </Col>
        </Row>
        <Row>
          <Col sm="9">
            <Remarks ApplNo={ApplNo ?? ""} />
          </Col>
          <Col sm="3">
            <Timeline ApplNo={ApplNo ?? ""} />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CandidateRecordContainer;
